import React from 'react';

export const renderTableHeader = headerData => {
  return headerData.map(column => {
    return <th key={column.text}>{column.text}</th>;
  });
};

export const renderTableData = (headerData, tableData) => {
  const isEmpty = accnt => Object.entries(accnt).length === 0;
  if (isEmpty(tableData)) {
    return (
      <tr key="0">
        <td>No data found between these dates</td>
      </tr>
    );
  }
  return tableData.map((row, index) => {
    return (
      <tr key={index}>
        {headerData.map(column => {
          return <td key={column.text}>{row[column.dataField]}</td>;
        })}
      </tr>
    );
  });
};

export const handleOkButtonClick = (accounts, value, okButtonClick) => {
  return value ? okButtonClick(accounts, value.dataset.value) : null;
};

export const renderPaginationButtons = (
  data,
  currentPage,
  itemsPerPage,
  lowerPageBound,
  upperPageBound,
  handlePaginateClick
) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return pageNumbers
    .map(number => {
      if (number === 1 && currentPage === 1) {
        return (
          <li
            className={number === currentPage ? 'active' : null}
            key={number}
            id={number}
            onClick={handlePaginateClick}
          >
            {number}
          </li>
        );
      } else if (number < upperPageBound + 1 && number > lowerPageBound) {
        return (
          <li
            className={number === currentPage ? 'active' : null}
            key={number}
            id={number}
            onClick={handlePaginateClick}
          >
            {number}
          </li>
        );
      }

      return null;
    })
    .filter(obj => obj != null);
};

export const renderPrevButton = (currentPage, totalPages, handleClick) =>
  currentPage !== 1 && totalPages > 1 ? <li onClick={handleClick}>Prev</li> : <li>Prev</li>;

export const renderDecrementButton = (lowerPageBound, handleClick) =>
  lowerPageBound >= 1 ? <li onClick={handleClick}>&hellip;</li> : null;

export const renderIncrementButton = (totalPages, upperPageBound, handleClick) =>
  totalPages > upperPageBound ? <li onClick={handleClick}>&hellip;</li> : null;

export const renderNextButton = (currentPage, totalPages, handleClick) =>
  currentPage !== totalPages ? <li onClick={handleClick}>Next</li> : <li>Next</li>;
